export default "__VITE_ASSET__DqQCYR8N__"